// import { EUserListingType } from '~/modules/adminModule/types/usersLists'

const groupPrefix = 'users'
export const apiUsers = {
	fetchAllUsersByStatus: async (page: number, perPage: number, status?: string, orderBy?: 'asc' | 'desc', email?: string) => {
		let url = groupPrefix

		const queryParams = []

		if (perPage && page) {
			queryParams.push(`per_page=${perPage}`)
			queryParams.push(`page=${page}`)
		}

		if (status) {
			queryParams.push(`status=${status}`)
		}

		if (orderBy) {
			queryParams.push(`order_by=${orderBy}`)
		}

		if (email) {
			queryParams.push(`email=${encodeURIComponent(email)}`)
		}

		if (queryParams.length > 0) {
			url += `?${queryParams.join('&')}`
		}

		const { data, links, meta } = await apiCommon<{ data: IUser[]; links: any; meta: any }>(url, {
			method: 'GET',
		})

		if (!data) return { response: [], links, meta }

		const response = data.map((user) => {
			return User(user)
		})
		return { response, links, meta }
	},

	getUsersAdminCounters: async () => {
		const { data } = await apiCommon<{ data: { count: IUserAdminCounters } }>(`${groupPrefix}/counters`, { method: 'GET' })
		return UserAdminCounters(data.count)
	},

	fetchUserByID: async (id: string) => {
		const { data } = await apiCommon<{ data: IUser }>(`${groupPrefix}/${id}`, { method: 'GET' })
		return User(data)
	},

	updateUserByID: async (id: number, user: Partial<IUserModel>) => {
		const { data } = await apiCommon<{ data: IUser }>(`${groupPrefix}/${id}`, { method: 'PUT', body: userToJSON(user) })
		return User(data)
	},

	deleteUserByID: async (id: number) => {
		const { data } = await apiCommon<{ data: IUser }>(`${groupPrefix}/${id}`, { method: 'DELETE' })
		return data
	},
}
